export class RelatedItemModel {
    constructor (
        public requestId: string,
        public fromDocId: string,
        public recDocId: string,
        public method: string,
        public title: string,
        public sourceType: string,
        public author: string,
        public pubTitle: string,
        public pubDate: string,
        public resourceTypeIcon: string
    ) {}
}
